import { PartnerOrganizationMemberListQuery, PartnerOrganizationMemberListResponseDto, PartnerOrganizationMemberResponseDto, } from '@lucidlink/dto/web-service-api';
import { arrayParserFromDto, parserFromDto } from '#fetcher/parse-utils';
export const createPartnerOrganizationMemberManager = ({ partnerOrganizationFetcher, }) => new PartnerOrganizationMemberManagerImpl(partnerOrganizationFetcher);
class PartnerOrganizationMemberManagerImpl {
    membersFetcher;
    constructor(partnerOrganizationFetcher) {
        this.membersFetcher = partnerOrganizationFetcher.createSubFetcher({
            path: 'members',
        });
    }
    async getMember(memberId) {
        return this.membersFetcher.get([memberId.toString()], {
            parser: parserFromDto(PartnerOrganizationMemberResponseDto),
        });
    }
    async addMembers(params) {
        return this.membersFetcher.post([], {
            body: params,
            parser: arrayParserFromDto(PartnerOrganizationMemberResponseDto),
        });
    }
    async updateMember(memberId, params) {
        return this.membersFetcher.patch([memberId.toString()], {
            body: params,
            parser: parserFromDto(PartnerOrganizationMemberResponseDto),
        });
    }
    getMembers(params = {}) {
        return this.membersFetcher.get([], {
            queryParams: PartnerOrganizationMemberListQuery.encode(params),
            parser: parserFromDto(PartnerOrganizationMemberListResponseDto),
        });
    }
    async removeMember(memberId) {
        await this.membersFetcher.delete([memberId.toString()]);
    }
}
